import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=fccd53c6&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"
import style0 from "./questionItem.vue?vue&type=style&index=0&id=fccd53c6&prod&lang=scss&scoped=true"
import style1 from "./questionItem.vue?vue&type=style&index=1&id=fccd53c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd53c6",
  null
  
)

export default component.exports